import { render, staticRenderFns } from "./DialogLoad.vue?vue&type=template&id=eed23508&scoped=true&"
import script from "./DialogLoad.vue?vue&type=script&lang=ts&"
export * from "./DialogLoad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed23508",
  null
  
)

export default component.exports